import { Monitor, Moon, Sun } from "lucide-react";
import { Theme, useTheme } from "@/lib/theme-provider";
import { ToggleGroup, ToggleGroupItem } from "./toggle-group";

export function ThemeToggle() {
	const { setTheme, theme } = useTheme();

	// Convert theme enum to string for toggle group value
	const currentTheme =
		theme === Theme.LIGHT ? "light" : theme === Theme.DARK ? "dark" : "system";

	return (
		<div className="flex items-center justify-between gap-2 w-full">
			<p className="text-sm">Theme</p>
			<ToggleGroup
				type="single"
				variant="outline"
				value={currentTheme}
				onValueChange={(value) => {
					if (value) {
						setTheme(value as Theme);
					}
				}}
				size="sm"
			>
				<ToggleGroupItem value={Theme.LIGHT} aria-label="Light theme">
					<Sun className="h-4 w-4" />
				</ToggleGroupItem>
				<ToggleGroupItem value={Theme.DARK} aria-label="Dark theme">
					<Moon className="h-4 w-4" />
				</ToggleGroupItem>
				<ToggleGroupItem value={Theme.SYSTEM} aria-label="System theme">
					<Monitor className="h-4 w-4" />
				</ToggleGroupItem>
			</ToggleGroup>
		</div>
	);
}
